import $ from 'jquery';
import { saveNewTags } from './saveNewTags';
import { showSidebarTab } from '~src/sidebarLegacy';
import { getState } from '~src/state';
import { handleSidebarBackgrounds, handleSidebarImages } from '~src/sidebar';

export const onclickSaveTagsImage = async (event) => {
  const sidebarCurrentImagesTagItemId = $(event.currentTarget).data(
    'save-tag-image-id'
  );
  const isUserOwner = $(event.currentTarget).data('save-tag-image-user-owner');
  const selectedTags = $('#tagImageSelect').val();
  await saveNewTags(sidebarCurrentImagesTagItemId, selectedTags, isUserOwner);
  const parentTab = getState('currentSidebarTab');
  if (parentTab) {
    showSidebarTab(parentTab);
    if (parentTab === 'manifesti') {
      await handleSidebarBackgrounds(true);
    } else if (parentTab === 'immagini') {
      await handleSidebarImages(true);
    }
  }
};
